export const year = () => {
  const year: { label: number; value: number }[] = [];
  const yearNow = new Date().getFullYear();
  for (let i = yearNow; i >= yearNow - 110; --i) {
    year.push({ label: i, value: i });
  }
  return year;
};
export const month = () => {
  const month: { label: string | number; value: string | number }[] = [];
  for (let i = 1; i <= 12; i++) {
    if (i < 10) {
      month.push({ label: `0${i}`, value: `0${i}` });
    } else {
      month.push({ label: i, value: i });
    }
  }
  return month;
};

export const date = (year: number, month: number) => {
  const date: { label: number | string; value: number | string }[] = [];
  const now = year !== 0 && month !== 0 ? new Date(year, month, 0).getDate() : 0;
  if (now > 0) {
    for (let i = 1; i <= now; i++) {
      if (i < 10) {
        date.push({ label: `0${i}`, value: `0${i}` });
      } else {
        date.push({ label: i, value: i });
      }
    }
  }
  return date;
};

export const convertSpaceToFullWidth = (value: string) => value.replace(/\s+/g, '　');
